import 'vuetify/styles'
import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { md3 } from 'vuetify/blueprints'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Material Design Icons
import '@mdi/font/css/materialdesignicons.css'

export const vuetify = createVuetify({
  blueprint: md3,
  components,
  directives,

  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },

  theme: {
    defaultTheme: 'light',
    variations: {
      colors: ['primary', 'grey'],
      lighten: 5,
      darken: 5,
    },
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#ffffff',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#FF5252',
          success: '#81BE00',
          surface: '#ffffff',
          background: '#ffffff',
          grey: '#9e9e9e',
        },
      },
    },
  },

  defaults: {
    global: {
      style: {
        fontFamily: 'open-sans, sans-serif',
      },
    },
  },
})

export default vuetify
